<!--  -->
<template>
  <div>
    <zlr-title title="Fill out time spent (mins)"></zlr-title>
    <div class="mentee-feedback-time-prompt">
      Your time will not be remunerated if it exceeds the maximum allowance of a module.
    </div>
    <ul>
      <li>
        <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
        <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Max time)：{{remainTime.maxTime}}mins</li>
      <li>
        <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
        <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Used time)：{{remainTime.usedTime}}mins</li>
      <li>
        <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
        <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Remaining time)：{{remainTime.remainTime}}mins</li>
    </ul>
    <div class="mentee-feedback-time-expected">
      Expected discussion time：{{appDetail.predictTime}}mins
    </div>
  </div>
</template>

<script>
// api
import { getAppRemainTime } from '@/api/appointment'
// components
import ZlrTitle from '_c/title/title'
export default {
  name: 'mentee-feedback-spent-time',
  props: ['appDetail', 'isPackageId'],
  components: {
    ZlrTitle
  },
  data () {
    return {
      remainTime: {}
    }
  },
  computed: {},
  mounted () {
    this.getAppRemainTime()
  },
  methods: {
    getAppRemainTime () {
      let appDetail = this.appDetail
      getAppRemainTime({
        'id': appDetail.id
      }).then(res => {
        this.remainTime = res.data.model
        this.$emit('on-detail', res.data.model)
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
